(function($) {

	$.fn.excludeSubmit = function() {

		return this.each(function() {
			var $this = $(this);

            // Temp disable field to exclude it from submit
            $this.closest('form').on('submit', function () {
                if ($this.is(':enabled')) {
                    $this.prop('disabled', true);

                    // A short timeout allows the form to submit and queues the field for re-enablement afterwards
                    setTimeout(function () {
                        $this.prop('disabled', false);
                    }, 1);
                }
            });
        });
	};

})(jQuery);